import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import SignDocument from './pages/SignDocument';
import Success from './pages/Success';
import Admin from './pages/Admin';
import AdminEditDocument from './pages/AdminEditDocument';
import Verify from './pages/Verify';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sign/:documentId" element={<SignDocument />} />
          <Route path="/success" element={<Success />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/edit/:documentId" element={<AdminEditDocument />} />
          <Route path="/verify/:documentId" element={<Verify />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;